const SimpleCrypto = require('simple-crypto-js').default;
const SimpleCryptoLegacy = require('simple-crypto-js-legacy').default;
const { SHA256 } = require('crypto-js');

const ERROR_INCORRECT_SECRET = 'Incorrect password';

// Function to decrypt with automatic fallback: try 2.5.0 first, then 2.0.2 if it fails
const decrypt = (encryptedText, secret) => {
  try {
    // Try current version (2.5.0) first
    const simpleCrypto = new SimpleCrypto(secret);
    const decrypted = simpleCrypto.decrypt(encryptedText).toString();

    if (decrypted === null || decrypted === undefined) {
      throw new Error(ERROR_INCORRECT_SECRET);
    }

    return {
      decryptedString: decrypted,
      version: '2.5.0',
    };
  } catch (error) {
    console.error('Version 2.5.0 failed, trying legacy version 2.0.2...');

    try {
      // Fallback to legacy version (2.0.2)
      const simpleCryptoLegacy = new SimpleCryptoLegacy(secret);
      const decrypted = simpleCryptoLegacy.decrypt(encryptedText).toString();

      if (decrypted === null || decrypted === undefined) {
        throw new Error(ERROR_INCORRECT_SECRET);
      }

      return {
        decryptedString: decrypted,
        version: '2.0.2',
      };
    } catch (legacyError) {
      console.error('Both versions failed:', error.message, legacyError.message);
      throw new Error(ERROR_INCORRECT_SECRET);
    }
  }
};

const hash = (value) => {
  return SHA256(value).toString();
};

// For backward compatibility, export a crypto object
const crypto = {
  decrypt,
  hash,
  ERROR_INCORRECT_SECRET,
};

module.exports = {
  decrypt,
  hash,
  crypto,
  ERROR_INCORRECT_SECRET,
};
